//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/DebugSession.js";
let d=[[],[],[["AdmTemplates","AdmTemplateTestManager",0],["ArchTemplates","ArchTemplateTestManager",0],["AssemTemplates","AssemTemplateTestManager",0],["CaeTemplates","CaeTemplateTestManager",0],["CamTemplates","CamTemplateTestManager",0],["DraftTemplates","DraftTemplateTestManager",0],["FfmTemplates","FfmTemplateTestManager",0],["KdaTemplates","KdaTemplateTestManager",0],["ModlTemplates","ModlTemplateTestManager",0],["NxsmTemplates","NxsmTemplateTestManager",0],["PerfTemplates","PerfTemplateTestManager",0],["PsasmTemplates","PsasmTemplateTestManager",0],["PsaTemplates","PsaTemplateTestManager",0],["RoutTemplates","RoutTemplateTestManager",0],["TcinTemplates","TcinTemplateTestManager",0],["LineDesignerTemplates","LineDesignerTemplateTestManager",0],["CmmInspectTemplates","CmmInspectTemplateTestManager",0],["ToolDesignerTemplates","ToolDesignerTemplateTestManager",0],["ALPTemplates","ALPTemplateTestManager",0]]];
SPLM.TemplateTestManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.TemplateTestManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;